import { BotId, HostingVersionCatalogue } from '@feedyou-ai/feedbot-schema'
import { AppKind } from '@feedyou/utils'

import { serverApi, ServerApiTag } from '../../store/serverApi'
import { HostingMetadata } from '../serverBots/types'
import { sortCatalogueVersions } from './utils'

export type HostingUpdateLog = {
  updateTimestamp: number
  version: string
  featureBranch?: string
  commit: string
}

export const hostingVersionsApi = serverApi.injectEndpoints({
  endpoints: builder => ({
    getHostingVersionsCatalogue: builder.query<
      { releases: HostingVersionCatalogue },
      { forAppKind: AppKind }
    >({
      query: ({ forAppKind }) => ({ url: 'hosting-versions', params: { forAppKind } }),
      serializeQueryArgs: () => 'hosting-versions',
      transformResponse: (res: { releases: HostingVersionCatalogue }) => {
        return { releases: sortCatalogueVersions(res.releases) }
      },
      providesTags: [ServerApiTag.HOSTING_VERSIONS]
    }),
    getHostingUpdateHistory: builder.query<HostingUpdateLog[], { botId: BotId }>({
      query: args => `/bots/${args.botId}/hosting-update-history`,
      serializeQueryArgs: ({ queryArgs }) => `/bots/${queryArgs.botId}/hosting-update-history`,
      providesTags: [ServerApiTag.HOSTING_UPDATE_HISTORY]
    }),
    getHostingMetadata: builder.query<HostingMetadata, { botId: BotId }>({
      query: ({ botId }) => `bots/${botId}/tree`,
      providesTags: (_, __, arg) => [ServerApiTag.BOT_DEPLOYED_TREE(arg.botId)]
    })
  })
})
